<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a">CONTENTS</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><span href="#/chapter01" title="Link target outside of Sample">1. Ashokan Reservoir Towns: Drop by Drop</span></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Roseton: Brick by Brick</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Rockland Lake: From Town to Park</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Camp Shanks: Last Stop U.S.A.</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Shanks Village: The PhD Pad</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9a2a0684